import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import Gallery from "./pages/Gallery/Gallery";
import Menu from "./pages/Menu/Menu";
import AboutUs from "./pages/AboutUs/AboutUs";
import Apartments from "./pages/Apartments/Apartments";
import Playroom from "./pages/Playroom/Playroom";
import GreatHall from "./pages/GreatHall/GreatHall";
import CrystalHall from "./pages/CrystalHall/CrystalHall";
import SmallHall from "./pages/SmallHall/SmallHall";
import ScrollOnTop from "./ScrollOnTop";

function App() {
  return (
    <ScrollOnTop>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/apartments" element={<Apartments />} />
        <Route path="/playroom" element={<Playroom />} />
        <Route path="/great-hall" element={<GreatHall />} />
        <Route path="/crystal-hall" element={<CrystalHall />} />
        <Route path="/small-hall" element={<SmallHall />} />
      </Routes>
    </ScrollOnTop>
  );
}

export default App;
